/* istanbul ignore file */
export enum EventBookingErrorCodes {
  NotEnoughCapacity = "NotEnoughCapacity",
  NotEnoughCapacityMultipleBookings = "NotEnoughCapacityForMultipleBookings",
  EventNotFound = "EventNotFound",
  BookingAlreadyExists = "BookingAlreadyExists",
  IncorrectParameterUsage = "IncorrectParameterUsage",
  UserConfigurationError = "UserConfigurationError",
  ConflictingRequest = "ConflictingRequest"
}
